import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { authenticationService } from '../services/authentication.service';

export const PrivateRoute = ({ children }) => {
  const location = useLocation(); 


  useEffect(() => {
    // whenever the path changes, store it
    // localStorage.setItem('lastRoute', location.pathname + location.search);
  }, [location]);

  if (authenticationService.isLoggedIn()) {
    return children;
  }

  // If not logged in, navigate to login and pass the current path as state
  const currentPath = window.location.pathname + window.location.search;
  const returnUrl = encodeURIComponent(currentPath);
   window.location.href = `/login?returnUrl=${returnUrl}`;
  // return <Navigate to="/login" state={{ from: location }} replace />;
};
